import { useQuery } from "@tanstack/react-query";
import adminApiClient, { KlydoGreetOrderStats } from "../../api/admin";

export type KlydoGreetOrderRange =
  | { days: number }
  | { from: string; to: string };

export const useKlydoGreetOrderStats = (range: KlydoGreetOrderRange) => {
  return useQuery<KlydoGreetOrderStats>({
    queryKey: ["klydoGreetOrderStats", range],
    queryFn: () => adminApiClient.getKlydoGreetOrderStats(range),
  });
};
